import { render, staticRenderFns } from "./EmbeddedProvider.vue?vue&type=template&id=136f29a6&scoped=true&"
import script from "./EmbeddedProvider.vue?vue&type=script&lang=js&"
export * from "./EmbeddedProvider.vue?vue&type=script&lang=js&"
import style0 from "./EmbeddedProvider.vue?vue&type=style&index=0&id=136f29a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136f29a6",
  null
  
)

export default component.exports